import * as React from 'react';
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { Action } from 'redux';
import { Modal, Button } from "antd";
import { changeSelectedPublishedVersion } from 'app/pages/AgentPricing/actions';
import { showPublishedVersionDialog, getSelectedPublishedVersion } from 'app/pages/AgentPricing/modules/PublishedVersions';
import { PublishedRatesTable } from 'app/pages/AgentPricing/components/RatesTableWidget';

export interface PublishedVersionDialogProps {}

interface StateProps {
    isOpen: boolean 
}

interface DispatchProps {
    onClose: () => void
}

type InternalProps = StateProps & DispatchProps

const PublishedVersionDialog = (props: InternalProps) => (
    <Modal
        title="Published Version"
        open={props.isOpen}
        onCancel={props.onClose}
        width="90%"
        footer={[
            <Button key="close" onClick={props.onClose}>
                Close
            </Button>
        ]}
        destroyOnHidden
    >
        {props.isOpen && <PublishedRatesTable />}
    </Modal>
);

  
const mapStateToProps = (state: any, ownProps: {}): StateProps => {
    return { 
        isOpen: showPublishedVersionDialog(state)
    };
};
  
const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return {
        onClose: () => dispatch(changeSelectedPublishedVersion('')) 
    }; 
};
  
export default connect(mapStateToProps, mapDispatchToProps)(PublishedVersionDialog);